import { AlertStatus, Link, useDisclosure } from '@chakra-ui/react';
import { AlertComponent } from 'components/alerts/AlertComponent';
import { LoadingSpinner } from 'components/loading/Loading';
import { RecentActivityLogModal } from 'components/modal/RecentActivityLogModal';
interface IWarning {
	message: string | JSX.Element;
	title: string;
	status: AlertStatus;
}
type WarningTypes =
	| 'not_exist_unrestricted_plan'
	| 'not_exist_restricted_plan'
	| 'exist_restricted_plan'
	| 'pending_restricted_plan';

const getWarning = (w: WarningTypes, onActivityModal: () => void): IWarning => {
	const warnings: Record<WarningTypes, IWarning> = {
		not_exist_unrestricted_plan: {
			title: 'Atenção.',
			message:
				'Não há plano irrestrito e restrito para o ciclo selecionado. Por favor, primeiro realize o consenso.',
			status: 'warning',
		},
		not_exist_restricted_plan: {
			title: 'Atenção.',
			message:
				'Não há plano restrito para o ciclo selecionado. Por favor, clique em “Gerar Plano”.',
			status: 'warning',
		},
		exist_restricted_plan: {
			title: 'Plano restrito gerado.',
			message:
				'Caso deseja atualizar o plano, edite as quantidades diretamente na tabela.',
			status: 'success',
		},
		pending_restricted_plan: {
			title: 'Plano restrito em processamento.',
			message: (
				<>
					A geração do Plano Restrito foi iniciada. Acompanhe o
					progresso{' '}
					<Link
						textDecoration='underline'
						_hover={{ textDecoration: 'underline' }}
						_focus={{ textDecoration: 'underline' }}
						onClick={onActivityModal}
					>
						aqui
					</Link>
					.
				</>
			),
			status: 'info',
		},
	};
	return warnings[w];
};

const getWarningType = (
	existsRestrictedPlan?: boolean,
	isJobPending?: boolean,
	existsUnrestrictedPlan?: boolean
): WarningTypes | undefined => {
	if (
		existsRestrictedPlan === undefined ||
		existsUnrestrictedPlan === undefined
	) {
		return;
	}
	if (isJobPending) {
		return 'pending_restricted_plan';
	}
	if (!existsRestrictedPlan && !existsUnrestrictedPlan) {
		return 'not_exist_unrestricted_plan';
	}
	if (!existsRestrictedPlan && existsUnrestrictedPlan) {
		return 'not_exist_restricted_plan';
	}
	if (existsRestrictedPlan) {
		return 'exist_restricted_plan';
	}
};

interface IPlanStatusAlertProps {
	existsRestrictedPlan?: boolean;
	isJobPending?: boolean;
	existsUnrestrictedPlan?: boolean;
	isLoading?: boolean;
}
export const PlanStatusAlert = ({
	existsRestrictedPlan,
	isJobPending,
	existsUnrestrictedPlan,
	isLoading,
}: IPlanStatusAlertProps) => {
	const {
		isOpen: isActivityModalOpen,
		onOpen: onOpenActivityModal,
		onClose: onActivityModalClose,
	} = useDisclosure();
	const warningType = getWarningType(
		existsRestrictedPlan,
		isJobPending,
		existsUnrestrictedPlan
	);
	console.log('warningType', warningType);
	if (isLoading || !warningType) {
		return <LoadingSpinner />;
	}
	const warning = getWarning(warningType, onOpenActivityModal);
	const { message, status, title } = warning;
	return (
		<>
			<RecentActivityLogModal
				isOpen={isActivityModalOpen}
				onClose={onActivityModalClose}
			/>
			<AlertComponent
				status={status}
				title={title}
				description={message}
				hasCloseButton
				mb={'0px'}
			/>
		</>
	);
};
